export default __webpack_public_path__ + "assets/img/savings_swoosh_xl_lg_md.svg";